import React, { createContext, useContext, useRef } from 'react';

/**
 * Ref to the function that opens the import popup (from Sidebar/ActionButtons).
 * Used to offer "Import tasks" from various entry points.
 */
const ImportPopupContext = createContext({ current: null });

export function ImportPopupProvider({ children }) {
  const openImportPopupRef = useRef(null);
  return (
    <ImportPopupContext.Provider value={openImportPopupRef}>
      {children}
    </ImportPopupContext.Provider>
  );
}

export function useImportPopupRef() {
  return useContext(ImportPopupContext);
}
